import React, { useState, useEffect } from 'react';
import { Link, useLocation } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import axios from 'axios';
import { API_URL } from '../config/api';
import SEO from '../components/SEO';
import './Auth.css';

const CheckEmail = () => {
  const { t } = useTranslation();
  const location = useLocation();
  const [email, setEmail] = useState('');
  const [message, setMessage] = useState('');
  const [error, setError] = useState('');
  const [loading, setLoading] = useState(false);

  useEffect(() => {
    if (location.state?.email) setEmail(location.state.email);
    if (location.state?.message) setMessage(location.state.message);
  }, [location.state]);

  const handleResend = async (e) => {
    e.preventDefault();
    if (!email.trim()) return;
    setLoading(true);
    setError('');
    setMessage('');
    try {
      const { data } = await axios.post(`${API_URL}/auth/resend-verification`, {
        email: email.trim()
      });
      setMessage(data.message || t('auth.verificationEmailSent') || 'We sent a new verification link to your email.');
    } catch (err) {
      setError(err.response?.data?.message || t('auth.resendVerificationError') || 'Failed to send. Try again.');
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="auth-container">
      <SEO title={t('auth.checkYourEmail') || 'Check your email'} path="/check-email" noIndex />
      <div className="auth-card">
        <h2>{t('auth.checkYourEmail') || 'Check your email'}</h2>
        <p className="auth-subtext" style={{ marginBottom: '1rem' }}>
          {message || t('auth.verifyEmailInstructions') || 'We sent a verification link to your email. Click the link to verify your account, then you can log in.'}
        </p>
        <p className="auth-link">
          <Link to="/login">{t('auth.backToLogin') || 'Back to login'}</Link>
        </p>
        <hr style={{ margin: '1.5rem 0', border: 'none', borderTop: '1px solid #eee' }} />
        <p style={{ fontSize: '0.95rem', color: '#666', marginBottom: '0.75rem' }}>
          {t('auth.didntReceiveEmail') || "Didn't receive the email?"}
        </p>
        <form onSubmit={handleResend}>
          <div className="form-group">
            <label>{t('auth.email')}</label>
            <input
              type="email"
              value={email}
              onChange={(e) => { setEmail(e.target.value); setError(''); setMessage(''); }}
              required
              autoComplete="email"
              placeholder="your@email.com"
            />
          </div>
          {error && <div className="error-message">{error}</div>}
          {message && <div className="success-message">{message}</div>}
          <button type="submit" className="btn btn-primary" disabled={loading}>
            {loading ? (t('auth.sending') || 'Sending...') : (t('auth.resendVerification') || 'Resend verification email')}
          </button>
        </form>
      </div>
    </div>
  );
};

export default CheckEmail;
